







































































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';
import ProductCombobox from '@/components/Controls/ProductCombobox.vue';
import ProductContainerCombobox from '@/components/Controls/ProductContainerCombobox.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      warehouse_id: { required },
      resort_date: { required },
      product_id: { required },
      product_container_id: { required },
      from_product_id: {  },
      from_product_container_id: {  },
      quantity: { required },
      weight: { required },
      reasone: { required },
      client_id: { },
      deal_id: { },
    }

    return {
      form: rules
    }
  },
  components: {
    ProductCombobox,
    ProductContainerCombobox
  }
})
export default class WarehouseResortForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Boolean }) fileForm!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any;
  form!: any;
  upload_file: any = null;
  resortType: number = 0;
  resortTypes: any = {
    0: 'другое',
    1: 'пересорт',
    2: 'бой',
    3: 'срок годности',
    4: 'некондиция',
  }

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }
  setResortType(resortType: any) {
    this.resortType = resortType
    if (resortType > 0) {
      this.changeValue('reasone', this.resortTypes[resortType])
    } else {
      this.changeValue('reasone', '')
    }
  }

  setProduct(product: any) {
    this.$store.dispatch(`${STORE_KEY}/setProduct`, product);
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    this.$v.form.$touch();
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }
  closeForm() {
    (this.$parent as any).close();
  }

  uploadFile(file: File, type: string) {
    const formData = new FormData();

    formData.append('warehouse_id', this.initParams.warehouse_id);
    formData.append('manager_id', this.initParams.manager_id);
    formData.append('file', file);

    // @ts-ignore
    this.$http.post(`/api/v1/warehouse_remains_import`,
      formData, {}
    ).then((response: any) => {
      (this.$parent as any).close();
      this.$buefy.toast.open({
        message: `Файл ${file.name} импортирован`,
        type: 'is-success'
      })
    })
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

